import { Injectable } from '@angular/core';
import { DialogType } from '@jms/model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DialogService {

    private _dialog$ = new BehaviorSubject<DialogType>(DialogType.None);
    public readonly dialog$ = this._dialog$.asObservable();
    public get dialog(): DialogType { return this._dialog$.value; }

    private _modalDialog$ = new BehaviorSubject<DialogType>(DialogType.None);
    public readonly modalDialog$ = this._modalDialog$.asObservable();
    public get modalDialog(): DialogType { return this._modalDialog$.value; }

    public showDialog(dialog: DialogType) {
        this._dialog$.next(dialog);
    }

    public dismissDialog() {
        this._dialog$.next(DialogType.None);
    }

    public showModalDialog(dialog: DialogType) {
        this._modalDialog$.next(dialog);
    }

    public dismissModal() {
        this._modalDialog$.next(DialogType.None);
    }
}